/* eslint-disable eslint-comments/disable-enable-pair */
export const tngaTaggingObjName = 'tngaDataLayer';
export const personalData = 'personal-data';
export const quotationCalculated = 'quotation-calculated';
export const quotationCompleted = 'quotation-completed';
export const quotationCompletedLaunchOffer = 'quotation-completed-launch-offer';
export const quotationConfirmed = 'quotation-confirmed';
export const configureProduct = 'configure-product';
export const errorPage = 'error-screen';
export const crashScreen = 'error-crash-screen';
export const claimsPage = 'claims-page';
export const optionalProduct = 'optional-product';
export const claimsScreen = 'claims-screen';
export const insurancePage = 'preselected-insurance-info-screen';
export const deductiblesSelection = 'deductibles-selection';
export const icWorkflowAction = 'ic-workflow';
export const personalDetails = 'personal-details';

export const taggingCloseEventValue: Record<string | number, string> = {
  1: personalData,
  2: quotationCalculated,
  3: optionalProduct,
  4: deductiblesSelection,
  6: errorPage, // click on x close button on error page
  5: claimsPage, // click on x close button on claims page
  7: insurancePage,
};

export const taggingMappingCloseEventUC: Record<string, string> = {
  'personal-data': configureProduct,
  'quotation-calculated': quotationCompleted,
  'optional-product': optionalProduct,
  'deductibles-selection': deductiblesSelection,
  'error-crash-screen': crashScreen,
  'error-screen': errorPage,
  'claims-page': errorPage,
  'preselected-insurance-info-screen': insurancePage,
  'claims-screen': claimsScreen,
};

export const taggingNCCloseEventValue: Record<string | number, string> = {
  1: configureProduct,
  2: quotationCompleted,
  3: optionalProduct,
  claims: claimsScreen,
};

export const taggingNCSpeedboatCloseEventValue: Record<string | number, string> = {
  1: configureProduct,
  2: personalDetails,
  3: quotationCompleted,
  claims: claimsScreen,
  launchOffer: quotationCompletedLaunchOffer,
};

export const taggingNCNextEventValue: Record<string | number, string> = {
  1: configureProduct,
  2: quotationCompleted,
  3: optionalProduct,
};

export const taggingNCBackEventValue: Record<string | number, string> = {
  4: deductiblesSelection,
  3: optionalProduct,
  2: quotationCompleted,
};

export const taggingNCSpeedboatNextEventValue: Record<string | number, string> = {
  1: configureProduct,
  2: personalDetails,
  3: quotationCompleted,
};

export const taggingNCSpeedboatBackEventValue: Record<string | number, string> = {
  3: quotationCompleted,
  2: personalDetails,
};

export interface TngaEventObject {
  name: string;
  componentName: string;
  componentGroup: string;
  action: string;
  label: string | null;
}

export interface TngaWorkflowObject {
  name: string;
  conversion: string;
  step: string | null;
  source?: string;
  variant?: string | null;
}

export interface TngaProductObject {
  subCategory?: string;
  category?: string;
  productInfo: ITngaProductInfo;
}

export interface ITngaProductInfo {
  productName: string;
  monthlyfee: number;
  yearlyfee: number;
  currencyCode: string;
}

export const mapT1ProductsToTngaProducts = (
  t1Products: Array<Record<string, string | number>> | undefined
): Array<ITngaProductInfo> =>
  t1Products?.map((insuranceProduct) => ({
    productName: insuranceProduct.productname as string,
    monthlyfee: insuranceProduct.monthlyfee as number,
    yearlyfee: insuranceProduct.yearlyfee as number,
    currencyCode: insuranceProduct.currency as string,
  })) || [];
